import { get, post } from './AxiosClient';
import type {
  ChatRequestBody,
  ChatResponse,
  DashboardAnalytics,
  LoginResponse,
  TranscriptionResponse,
  TranscriptionSearchResponse,
} from './types';

export const login = async (
  username: string,
  password: string
): Promise<LoginResponse | undefined> => {
  try {
    const response = await post<LoginResponse>('/login', { username, password });
    return response;
  } catch (error) {
    console.error('Error during login:', error);
    return undefined;
  }
};

export const fetchTranscriptions = async (
  limit: number = 10,
  orderBy: string = 'desc',
  lastEvaluatedKey?: Record<string, any>
): Promise<TranscriptionResponse | undefined> => {
  try {
    const params: Record<string, any> = { limit, sort_order: orderBy };

    if (lastEvaluatedKey) {
      params.last_evaluated_key = lastEvaluatedKey;
    }

    const response = await get<TranscriptionResponse>('/transcriptions', params);
    return response;
  } catch (error) {
    console.error('Error fetching transcriptions:', error);
    return undefined;
  }
};

export const fetchSearchedTranscriptions = async (
  query: string
): Promise<TranscriptionSearchResponse | undefined> => {
  try {
    const params: Record<string, any> = { query };
    const response = await get<TranscriptionSearchResponse>('/search-transcriptions', params);
    return response;
  } catch (error) {
    console.error('Error fetching transcriptions:', error);
    return undefined;
  }
};

export const fetchDashboardAnalytics = async (): Promise<DashboardAnalytics[] | undefined> => {
  try {
    const response = await get<DashboardAnalytics[]>('/dashboard');
    return response;
  } catch (error) {
    console.error('Error fetching dashboard analytics:', error);
    return undefined;
  }
};

export const postChatMessage = async (query: string): Promise<ChatResponse | undefined> => {
  try {
    const requestBody: ChatRequestBody = { query };
    const response = await post<ChatResponse>('/ask-question', requestBody);
    return response;
  } catch (error) {
    console.error('Error during sending msg:', error);
    return undefined;
  }
};
